import Table from 'components/CncUI/Table';
import Head from './Head';
import Body from './Body';
import arrayMove from 'utilities/arrayMove';

const AccountsTable = props => {
  const { mappings, amountType, multiple, items, error } = props;
  const { setItems, onKey, onChange, onRemove, isCurrencyEnabled } = props;

  return (
    <Table>
      <Head multiple={multiple} items={items} />
      <Body
        useDragHandle
        items={items}
        onSortEnd={({ oldIndex, newIndex }) => {
          const ordered = arrayMove(items, oldIndex, newIndex);
          setItems(
            ordered.map((account, index) => ({
              ...account,
              primary: index === ordered.length - 1,
            })),
          );
        }}
        onKey={onKey}
        onChange={onChange}
        onRemove={onRemove}
        mappings={mappings}
        multiple={multiple}
        amountType={amountType}
        error={error}
        isCurrencyEnabled={isCurrencyEnabled}
      />
    </Table>
  );
};

export default AccountsTable;
